import { motion } from "framer-motion";

const stats = [
  { value: "100%", label: "Atmospheric water — not a single drop taken from the ground" },
  { value: "12,900km³", label: "Of fresh moisture renewed in the atmosphere — nature's endless reservoir" },
  { value: "0.002%", label: "Of atmospheric moisture needed to hydrate all humanity" },
  { value: "Zero", label: "Reject water — our closed-loop process wastes nothing" },
  { value: "8.5pH", label: "Alkalinity achieved through precise mineral enrichment" },
  { value: "5M litres", label: "Of groundwater saved yearly when 1,000 people choose Nyla daily" },
];

export const Stats = () => (
  <section data-testid="stats-section" className="py-24 md:py-32 lg:py-40 bg-white">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8 }}
        className="text-center mb-16 md:mb-24"
      >
        <p className="text-xs md:text-sm tracking-[0.2em] uppercase font-semibold text-[#86868B] mb-6">Nature by the Numbers</p>
        <h2 data-testid="stats-heading" className="font-display text-4xl md:text-5xl lg:text-6xl leading-tight tracking-tight font-medium text-[#1D1D1F]">
          Numbers that redefine water.
        </h2>
      </motion.div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-x-8 gap-y-16 lg:gap-16">
        {stats.map((s, i) => (
          <motion.div
            key={s.value}
            data-testid={`stat-item-${i}`}
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.7, delay: (i % 3) * 0.12 }}
            className="text-center"
          >
            <p className="font-display text-5xl md:text-6xl lg:text-7xl font-semibold tracking-tighter text-[#1D1D1F]">
              {s.value}
            </p>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-[#86868B] max-w-xs mx-auto">{s.label}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
